import {memo, useEffect, useMemo, useRef} from 'react';
import toast from '@/components/HotToast';
import {AnalysisItem} from '@/map/@types';
import {useQueryDeliveryTiles} from '@/map/api';
import {MAX_VISIBLE_ZOOM_METER, MESSAGES} from '@/map/constants';
import {useVisibleZoomLevel} from '@/map/hooks';
import {getHeatMapOpacity, getIntlString} from '@/utils';
import {DeliveryBlock} from './Block';

interface IProps {
  map: naver.maps.Map;
  item: AnalysisItem;
}

export const DeliveryTileLayer = memo(({map, item}: IProps) => {
  const {data: rawdata} = useQueryDeliveryTiles(item);
  const data = useMemo(
    () => getHeatMapOpacity(rawdata, 'percent', 0, 0.8),
    [rawdata]
  );

  const toastId = useRef<string>();
  const isAvailableLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.tile);

  const showTile = item.delivery?.showTile;

  useEffect(() => {
    if (showTile && !isAvailableLevel) {
      toastId.current = toast(
        getIntlString(MESSAGES, 'area-analytics-zoom-warning', {
          type: '배달 비중을',
        }),
        {duration: Infinity}
      );
    } else if (toastId?.current) {
      toast.dismiss(toastId.current);
      toastId.current = undefined;
    }
  }, [isAvailableLevel, showTile]);

  useEffect(() => {
    return () => {
      if (toastId?.current) {
        toast.dismiss(toastId.current);
        toastId.current = undefined;
      }
    };
  }, []);

  if (!data?.length || !showTile) {
    return null;
  }

  return (
    <>
      {data.map((i) => (
        <DeliveryBlock key={i.tileId} map={map} item={i} />
      ))}
    </>
  );
});
